import buildPath from '@/tsClient/utilities/buildPath';
import integrationsClient, { ApiDefinition } from '@/tsClient/servers/integrationsService';

type THIS_API = ApiDefinition['/{provider}/creators/{creatorId}/submit-case']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const submitCase = async ({ creatorId, district, documentIds, username, userWorkflowId, password, provider }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/creators/{creatorId}/submit-case', { creatorId, provider });
  const response = await integrationsClient.post(path, {
    district,
    documentIds,
    password,
    userWorkflowId,
    username,
  });
  return response.data;
};

export default submitCase;
